export default "__VITE_ASSET__817b3843__"